<template>
  <span>
    <span v-if="isPercentageType">
      {{ tip.value }}%
    </span>
    <span v-if="isAbsoluteType">
      {{ currencySymbol }}{{ tip.value }}
    </span>
  </span>
</template>

<script>

export default {
  name: 'BookingTipConfig',
  props: {
    tip: {
      type: Object,
      required: true,
    },
    pricing: {
      type: Object,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: false,
      default: '$',
    },
  },
  computed: {
    isPercentageType() {
      return this.tip.base === 'percentage';
    },
    isAbsoluteType() {
      return this.tip.base === 'currency';
    },
  },
};
</script>

<style scoped>

</style>
